import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Search, Zap, Flame } from 'lucide-react';
import { Button } from '../ui/button';
import { API_URL } from './chatShared';
import { companyLabel } from '../client360/c360Shared';

export const ExistingContractPicker = ({ file, onDone }) => {
  const [nif, setNif] = useState('');
  const [rows, setRows] = useState(null);
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const search = async () => {
    try { const { data } = await axios.get(`${API_URL}/chat/contracts-by-nif`, { params: { nif } }); setRows(data); setSel(data.length === 1 ? [data[0].id] : []); } catch (e) { toast.error(e?.response?.data?.detail || 'Erro na pesquisa'); }
  };
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const attach = async () => {
    setBusy(true);
    try {
      const res = await Promise.allSettled(sel.map((cid) => axios.post(`${API_URL}/contracts/${cid}/attach-chat-files`, { file_ids: [file.id] })));
      const ok = res.filter((r) => r.status === 'fulfilled').length;
      const fail = res.length - ok;
      if (ok) toast.success(`Documento carregado em ${ok} contrato(s)`);
      if (fail) toast.error(`Falhou em ${fail} contrato(s)`);
      if (ok) onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erro ao carregar documento'); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid="chat-existing-picker">
      <div className="flex gap-2">
        <input value={nif} onChange={(e) => setNif(e.target.value.replace(/\D/g, '').slice(0, 9))} inputMode="numeric" placeholder="NIF do cliente"
          onKeyDown={(e) => e.key === 'Enter' && nif.length === 9 && search()} className="flex-1 border border-slate-300 rounded-md px-3 py-2 text-sm" data-testid="chat-existing-nif" />
        <Button type="button" disabled={nif.length !== 9} onClick={search} className="bg-[#2D3E6F] hover:bg-[#24335c]" data-testid="chat-existing-search"><Search className="w-4 h-4" /></Button>
      </div>
      {rows?.length === 0 && <p className="text-sm text-slate-400" data-testid="chat-existing-empty">Sem contratos para este NIF.</p>}
      {rows?.length > 0 && (
        <div className="max-h-72 overflow-y-auto divide-y divide-slate-100 border border-slate-100 rounded-lg">
          {rows.map((c) => (
            <label key={c.id} className={`flex items-start gap-2 px-3 py-2 text-sm cursor-pointer ${sel.includes(c.id) ? 'bg-sky-50' : 'hover:bg-slate-50'}`} data-testid={`chat-existing-row-${c.id}`}>
              <input type="checkbox" checked={sel.includes(c.id)} onChange={() => toggle(c.id)} className="mt-1" data-testid={`chat-existing-check-${c.id}`} />
              <span className="min-w-0">
                <span className="block font-medium text-slate-800">{c.codigo || 'Sem código'} · {companyLabel(c.company)} <span className="text-xs text-slate-500">({c.status_label})</span></span>
                {c.cpe && <span className="flex items-center gap-1 text-xs text-slate-600"><Zap className="w-3 h-3 text-amber-500" />CPE {c.cpe}</span>}
                {c.cui && <span className="flex items-center gap-1 text-xs text-slate-600"><Flame className="w-3 h-3 text-orange-500" />CUI {c.cui}</span>}
                {c.morada_fornecimento && <span className="block text-xs text-slate-400 truncate">{c.morada_fornecimento}</span>}
              </span>
            </label>
          ))}
        </div>
      )}
      {rows?.length > 0 && (
        <Button type="button" disabled={!sel.length || busy} onClick={attach} className="w-full bg-[#2D3E6F] hover:bg-[#24335c]" data-testid="chat-existing-attach">
          Carregar documento em {sel.length} contrato(s)
        </Button>
      )}
    </div>
  );
};
